import { render, staticRenderFns } from "./BattleList.vue?vue&type=template&id=c9904e2a&scoped=true&"
import script from "./BattleList.vue?vue&type=script&lang=js&"
export * from "./BattleList.vue?vue&type=script&lang=js&"
import style0 from "./BattleList.vue?vue&type=style&index=0&id=c9904e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9904e2a",
  null
  
)

export default component.exports